import { Toast, TOAST_VISIBILITY_DURATIONS } from 'cdk-radial';
import { useIntl } from 'react-intl';
import { TOAST_POSITION, TOAST_VARIANTS } from 'common/constants';
import {
  clearSuccessMessage,
  getSuccessMessage
} from 'components/SuccessMessage/slice';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { messages } from './messages';

export const SuccessMessage = (): React.JSX.Element => {
  const successMessage: string = useAppSelector(getSuccessMessage);
  const dispatch = useAppDispatch();
  const intl = useIntl();
  return (
    <>
      {successMessage && (
        <Toast
          actions={[
            {
              onClick: () => {
                dispatch(clearSuccessMessage());
              },
              text: intl.formatMessage(messages.dismissButton),
              dataTestId: 'dismiss-btn'
            }
          ]}
          data-testid="toast-success"
          position={TOAST_POSITION.FIXED}
          variant={TOAST_VARIANTS.POSITIVE}
          content={successMessage}
          visibilityDuration={TOAST_VISIBILITY_DURATIONS.SEVEN_SECONDS}
          onVisibilityDurationEnd={() => {
            dispatch(clearSuccessMessage());
          }}
          id="toast-success"
        />
      )}
    </>
  );
};
